import { contentConstants } from "./constant";

export const initialState = {
    contentloading: null,
    imgloading: null,
    appContentApiLoading: null,
    loginApiLoading: null,
    faqLoading: null,
    announcementLoading: null,
    linksLoading: null,
    desktopBgIMGLoading:null,
};

export function loginLodingState(state = initialState, action) {
    switch (action.type) {
        case contentConstants.CONTENT:
            return { ...state, contentloading: action.payload }

        case contentConstants.IMAGES:
            return { ...state, imgloading: action.payload }

        case contentConstants.APP_CONTENT:
            return { ...state, appContentApiLoading: action.payload }

        case contentConstants.FOOTER_CONTENT:
            return { ...state, loginApiLoading: action.payload }

        case contentConstants.FAQ:
            return { ...state, faqLoading: action.payload }

        case contentConstants.ANNOUNCEMENT:
            return { ...state, announcementLoading: action.payload }

        case contentConstants.LINKS:
            return { ...state, linksLoading: action.payload }

            case contentConstants.DESKTOP_IMG:
                return { ...state, desktopBgIMGLoading: action.payload }

        default:
            return state;
    }
}